import { createBaseFields } from './baseSchema.js';

/**
 * Admin Roles collection schema
 * Document ID is the user's UID (adminRoles/{uid})
 */
export const adminRolesSchema = {
    ...createBaseFields('', ''),
    uid: { _value: '', _rule: 'this.size() > 0', _immutable: true },
    role: { _value: '', _enum: ['college_admin', 'employer_admin'], _immutable: true },
    // For college_admin
    collegeName: { _value: '', _optional: true, _immutable: true },
    // For employer_admin
    organizationId: { _value: '', _optional: true, _immutable: true },
    organizationName: { _value: '', _optional: true },
    assignedBy: { _value: '', _rule: 'this.size() > 0', _immutable: true },
    assignedAt: { _value: null, _rule: 'this is timestamp', _immutable: true },
    status: { _value: 'active', _enum: ['active', 'revoked'] }
};

/**
 * Create an admin role document
 */
export const createAdminRoleDocument = ({
    uid,
    role,
    collegeName = '',
    organizationId = '',
    organizationName = '',
    assignedBy
}) => {
    const display = role === 'college_admin' ? `College Admin - ${collegeName}` : `Employer Admin - ${organizationName || organizationId}`;
    const baseFields = createBaseFields(uid, display);

    return {
        ...baseFields,
        uid,
        role,
        ...(role === 'college_admin' ? { collegeName } : {}),
        ...(role === 'employer_admin' ? { organizationId, organizationName } : {}),
        assignedBy,
        status: 'active'
    };
};
